export const RECORDING_STATES = [
    "idle",
    "requesting-permission",
    "recording",
    "stopping",
    "uploading",
    "transcribing",
    "waiting-for-model",
    "streaming",
    "completed",
    "error",
    "cancelled",
];
export const RECORDING_TRANSITIONS = {
    idle: ["requesting-permission", "waiting-for-model", "cancelled"],
    "requesting-permission": ["recording", "error", "cancelled"],
    recording: ["stopping", "error", "cancelled"],
    stopping: ["uploading", "completed", "error", "cancelled"],
    uploading: ["transcribing", "error", "cancelled"],
    transcribing: ["waiting-for-model", "error", "cancelled"],
    "waiting-for-model": ["streaming", "error", "cancelled"],
    streaming: ["completed", "error", "cancelled"],
    completed: ["requesting-permission", "uploading", "waiting-for-model", "idle", "cancelled"],
    error: ["requesting-permission", "uploading", "waiting-for-model", "idle", "cancelled"],
    cancelled: ["requesting-permission", "idle"],
};
export class RecordingStateMachine {
    #state;
    constructor(initial = "idle") {
        this.#state = initial;
    }
    get state() {
        return this.#state;
    }
    canTransition(next) {
        return RECORDING_TRANSITIONS[this.#state].includes(next);
    }
    transition(next) {
        if (!this.canTransition(next)) {
            throw new Error(`Illegal recording transition: ${this.#state} -> ${next}`);
        }
        this.#state = next;
        return this.#state;
    }
}
export const SSE_EVENT_NAMES = [
    "session",
    "transcription",
    "model-start",
    "answer-delta",
    "usage",
    "completed",
    "error",
];
export function encodeSse(event) {
    const { event: eventName, ...payload } = event;
    return `event: ${eventName}\ndata: ${JSON.stringify(payload)}\n\n`;
}
export class SseDecoder {
    #buffer = "";
    push(chunk) {
        this.#buffer += chunk;
        const trailingCarriageReturn = this.#buffer.endsWith("\r");
        const complete = trailingCarriageReturn ? this.#buffer.slice(0, -1) : this.#buffer;
        const frames = complete.replaceAll("\r\n", "\n").replaceAll("\r", "\n").split("\n\n");
        this.#buffer = `${frames.pop() ?? ""}${trailingCarriageReturn ? "\r" : ""}`;
        return frames.flatMap((frame) => this.#decodeFrame(frame));
    }
    finish() {
        if (!this.#buffer.trim())
            return [];
        const frame = this.#buffer.replaceAll("\r\n", "\n").replaceAll("\r", "\n");
        this.#buffer = "";
        return this.#decodeFrame(frame);
    }
    #decodeFrame(frame) {
        let event = "message";
        const data = [];
        for (const line of frame.split("\n")) {
            if (!line || line.startsWith(":"))
                continue;
            const separator = line.indexOf(":");
            const field = separator === -1 ? line : line.slice(0, separator);
            let value = separator === -1 ? "" : line.slice(separator + 1);
            if (value.startsWith(" "))
                value = value.slice(1);
            if (field === "event")
                event = value;
            if (field === "data")
                data.push(value);
        }
        return data.length ? [{ event, data: data.join("\n") }] : [];
    }
}
//# sourceMappingURL=index.js.map